import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import PropTypes from 'prop-types';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink, getWebAppLink } from '@ifeng/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import Observer from '@researchgate/react-intersection-observer';

class ActivityBanner extends React.PureComponent {
    static propTypes = {
        activityOne: PropTypes.array,
        wxLaunch: PropTypes.object,
        isVideoShare: PropTypes.bool,
        base62Id: PropTypes.string,
        type: PropTypes.string,
    };

    activityHandle = (isSendCount = true, isJumpQQlink = false, isCall = true) => {
        const { base62Id, activityOne, type } = this.props;
        const activityUrl =
            (activityOne && activityOne[0] && activityOne[0].staticId) ||
            (activityOne && activityOne[0] && activityOne[0].url) ||
            '';
        const activityScheme = (activityOne && activityOne[0] && activityOne[0].source) || '';
        let kind = '';

        if (type === 'short') {
            kind = 'shortdoc';
        } else if (type === 'slide') {
            kind = 'pic';
        } else {
            kind = 'article';
        }

        h5PageCount([
            {
                behavior: 'action',
                type: 'hot_poster',
                other: {
                    ref: `ucms_${base62Id}`,
                    url: encodeURIComponent(location.href),
                    kind,
                },
            },
        ]);

        if (isCall) {
            if (activityScheme) {
                callApp({
                    docType: 'custom',
                    pid: activityScheme,
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1473191849934',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8821',
                    isJumpQQlink,
                });
            } else {
                location.href = activityUrl;
            }
        }
    };

    handleChange = (event, unobserve) => {
        const { type, base62Id } = this.props;
        let kind = '';

        if (type === 'short') {
            kind = 'shortdoc';
        } else if (type === 'slide') {
            kind = 'pic';
        } else {
            kind = 'article';
        }

        if (event.isIntersecting) {
            unobserve();
            h5PageCount([
                {
                    behavior: 'pageinfo',
                    type: 'hot_poster',
                    other: [`ucms_${base62Id}`, kind],
                },
            ]);
        }
    };

    render() {
        const { activityOne, wxLaunch, isVideoShare } = this.props;
        const activityImage = (activityOne && activityOne[0] && activityOne[0].thumbnail) || '';
        const activityScheme = (activityOne && activityOne[0] && activityOne[0].source) || '';
        const schemeLink =
            wxLaunch.wxLaunchType === 'weapp'
                ? getWebAppLink({
                      docType: 'custom',
                      pid: activityScheme,
                  })
                : getSchemeLink({
                      docType: 'custom',
                      pid: activityScheme,
                  });
        const wxLaunchSwitch = wxLaunch.wxLaunchSwitch;
        const wxLaunchType = wxLaunch.wxLaunchType;

        return activityImage ? (
            <Observer onChange={this.handleChange}>
                <div className={styles.activityBanner} onClick={this.activityHandle}>
                    <img className={styles.activityBannerImg} src={activityImage} />
                    {wxLaunchSwitch &&
                        activityScheme &&
                        !isVideoShare && (
                            <WxLaunchApp
                                launchType={wxLaunchType}
                                launchAppClick={this.activityHandle.bind(this, true, false, false)}
                                schemeLink={schemeLink}
                                launchAppFail={this.activityHandle.bind(this, false, true, true)}
                            />
                        )}
                </div>
            </Observer>
        ) : (
            ''
        );
    }
}

export default errorBoundary(ActivityBanner);
